import { colors, fonts } from '@grupoboticario/flora-tokens/dist/casaMagalhaesAmazonia/web/ds'

export const casaMagalhaesAmazonia = {
  colors,
  fonts,
}
